import { PanelType } from '../../../../panels/types';

export const metadataElementsPanelType: PanelType = {
  name: 'METADATA_ELEMENTS',
  location: 'left'
}; 